import { Injectable } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { FeesOverlayComponent } from './fees-overlay.component'
import { DialogService } from '@tokeet-frontend/tv3-platform'

@Injectable()
export class FeesOverlayService {
  constructor(private dialog: DialogService) {}

  public open(): MatDialogRef<FeesOverlayComponent> {
    const config = {
      panelClass: ['drawer-full-80'],
    }

    const dialogRef = this.dialog.openDrawer(FeesOverlayComponent, config)

    return dialogRef
  }
}
